module.exports = __webpack_public_path__ + "img/dark-tree.c9e37427.svg";